import {
	Anchor,
	Icon,
	MoreInfo
} from "client/Components";
import {
	PropsWithChildren,
	ReactElement
} from "react";
import styles from "./AnalyticsCard.module.less";

export const AnalyticsCard = (props: PropsWithChildren<{}>): ReactElement => {
	const {
		children
	} = props;

	return (
		<div className={styles.root}>
			{children}
		</div>
	);
};
AnalyticsCard.displayName = "AnalyticsCard";

export type AnalyticsCardTitleProps = {
	title?: string;
};

const AnalyticsCardTitle = (props: PropsWithChildren<AnalyticsCardTitleProps>): ReactElement => {
	const {
		children,
		title
	} = props;

	return (
		<h3
			title={title}
			className={styles.title}
		>
			{children}
		</h3>
	);
};
AnalyticsCardTitle.displayName = "AnalyticsCard.Title";

const AnalyticsCardSubtitle = (props: PropsWithChildren<{}>): ReactElement => {
	const { children } = props;

	return (
		<p className={styles.subtitle}>{children}</p>
	);
};
AnalyticsCardSubtitle.displayName = "AnalyticsCard.Subtitle";

export type AnalyticsCardInfoButtonProps = {
	onClick: () => void;
};

const InfoButton = (props: AnalyticsCardInfoButtonProps): ReactElement => {
	const {
		onClick
	} = props;

	return (
		<div className={styles.infoButton}>
			<MoreInfo
				onClick={onClick}
				trackingId="info"
			/>
		</div>
	);
};
InfoButton.displayName = "AnalyticsCard.InfoButton";

const AnalyticsCardContent = (props: PropsWithChildren<{}>): ReactElement => {
	const { children } = props;

	return (
		<div className={styles.content}>{children}</div>
	);
};
AnalyticsCardContent.displayName = "AnalyticsCard.Content";

export type AnalyticsCardFooterProps = {
	title: string | ReactElement;
	onClick: () => void;
};

const AnalyticsCardFooter = (props: AnalyticsCardFooterProps): ReactElement => {
	const {
		title,
		onClick
	} = props;

	return (
		<div className={styles.footer}>
			<Anchor
				className={styles.viewAllButton}
				onClick={onClick}
			>
				<span className={styles.viewAllButtonText}>
					{title}
				</span>
				<Icon value="arrow-right" />
			</Anchor>
		</div>
	);
};
AnalyticsCardFooter.displayName = "AnalyticsCard.Footer";

AnalyticsCard.Title = AnalyticsCardTitle;
AnalyticsCard.Content = AnalyticsCardContent;
AnalyticsCard.Subtitle = AnalyticsCardSubtitle;
AnalyticsCard.Footer = AnalyticsCardFooter;
AnalyticsCard.InfoButton = InfoButton;